export const teamMembers = [
  {
    name: "Thomas Johnson",
    role: "Developer, co-founder",
    image: "/assets/images/team/team-1.jpg",
    socials: [
      { platform: "Facebook", icon: "fa-facebook-f", url: "#" },
      { platform: "Twitter", icon: "fa-twitter", url: "#" },
      { platform: "Pinterest", icon: "fa-pinterest-p", url: "#" },
    ],
  },
  {
    name: "Emma Johnson",
    role: "UI/UX Designer, co-founder",
    image: "/assets/images/team/team-2.jpg",
    socials: [
      { platform: "Facebook", icon: "fa-facebook-f", url: "#" },
      { platform: "Twitter", icon: "fa-twitter", url: "#" },
      { platform: "Pinterest", icon: "fa-pinterest-p", url: "#" },
    ],
  },
  {
    name: "Marta Laning",
    role: "Web developer",
    image: "/assets/images/team/team-4.jpg",
    socials: [
      { platform: "Facebook", icon: "fa-facebook-f", url: "#" },
      { platform: "Twitter", icon: "fa-twitter", url: "#" },
      { platform: "Pinterest", icon: "fa-pinterest-p", url: "#" },
    ],
  },
  {
    name: "Marta Laning",
    role: "Art director, designer",
    image: "/assets/images/team/team-3.jpg",
    socials: [
      { platform: "Facebook", icon: "fa-facebook-f", url: "#" },
      { platform: "Twitter", icon: "fa-twitter", url: "#" },
      { platform: "Pinterest", icon: "fa-pinterest-p", url: "#" },
    ],
  },
];
export const teamMembers2 = [
  {
    name: "Timo Lambing",
    role: "Founder & CEO",
    image: "/assets/img/timo.jpg",
    socials: [
      { name: "LinkedIn", url: "https://www.linkedin.com/in/timolambing/" },
      { name: "Twitter", url: "#" },
      { name: "Github", url: "https://github.com/TimoLambing" },
    ],
  },
  {
    name: "Ann-Kristiin Reimann",
    role: "Chief of Marketing",
    image: "/assets/img/ann-kristiin.jpg",
    socials: [
      { name: "LinkedIn", url: "#" },
      { name: "Twitter", url: "#" },
      { name: "Instagram", url: "#" },
    ],
  },
  // Add more team members as needed
];

export const teamMembers3 = [
  {
    name: "Thomas Anderson",
    role: "Creative director",
    description:
      "Sed eget ipsum vel urna viverra iaculis. Aenean ligula arcu, porta in scelerisque vehicula eget metus.",
    imgSrc: "/assets/images/demo-strong/team/team-1.jpg",
  },
  {
    name: "Lukas Goodman",
    role: "Product designer",
    description:
      "Etiam nec purus lacus curabitur facilisis dolor odio, in cursus sem viverra nec maximus pretium.",
    imgSrc: "/assets/images/demo-strong/team/team-2.jpg",
  },
  {
    name: "Kelsie Rogers",
    role: "Web engineer",
    description:
      "Etiam at orli at tellus iaculis bibendum quis id ante proin posuere eros, eget blandit vestibulum vel.",
    imgSrc: "/assets/images/demo-strong/team/team-3.jpg",
  },
  {
    name: "Marta Carlson",
    role: "UI/UX designer",
    description:
      "Sed eget ipsum vel urna viverra iaculis. Aenean ligula arcu, porta in scelerisque vehicula eget metus.",
    imgSrc: "/assets/images/demo-strong/team/team-4.jpg",
  },
];
